export default __webpack_public_path__ + "static/media/screen4.57288662.webp";